import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
  partners: {
    retrieve (parameters) {
      return requester.post(`${BACKEND_API_V1_URL}/partners`, parameters)
    },
  },

  areas: {
    retrieve (id, parameters) {
      return requester.post(`${BACKEND_API_V1_URL}/partners/${id}/areas`, parameters)
    },
  }
}